import { LinearProgress, Typography } from '@mui/material';
import SchoolIcon from '@mui/icons-material/SchoolOutlined';
import CodeIcon from '@mui/icons-material/Code';
import WorkIcon from '@mui/icons-material/WorkOutline';
import { Flexbox } from '../foundation/Flex';
import { SmartMatchSimilarity } from '../../../common/similarities.types';
import CustomBR from '../foundation/CustomBR';

const SimilaritiesBreakdown = (props: SmartMatchSimilarity) => {
    const getColor = (value: number) => {
        if (value >= 0.7) return 'success';
        if (value >= 0.5) return 'warning';
        return 'error';
    };

    return <>
        {props.educationScore > 0.1 && <>
            <Flexbox marginBottom={0.2}>
                <SchoolIcon titleAccess="השכלה" fontSize="small" color="secondary" />
                <Typography color="secondary">&nbsp;השכלה - {(props.educationScore * 100).toFixed(1)}%</Typography>
            </Flexbox>
            <LinearProgress color={getColor(props.educationScore)} variant="determinate" value={props.educationScore * 100} />
        </>}

        <CustomBR />
        {props.experienceScore > 0.1 && <>
            <Flexbox marginBottom={0.2}>
                <WorkIcon titleAccess="ניסיון" fontSize="small" color="secondary" />
                <Typography color="secondary">&nbsp;ניסיון - {(props.experienceScore * 100).toFixed(1)}%</Typography>
            </Flexbox>
            <LinearProgress color={getColor(props.experienceScore)} variant="determinate" value={props.experienceScore * 100} />
        </>}
        <CustomBR />
        {props.hardSkillsScore > 0.1 && <>
            <Flexbox marginBottom={0.2}>
                <CodeIcon titleAccess="כישורים טכניים" fontSize="small" color="secondary" />
                <Typography color="secondary">&nbsp;כישורים טכניים - {(props.hardSkillsScore * 100).toFixed(1)}%</Typography>
            </Flexbox>
            <LinearProgress color={getColor(props.hardSkillsScore)} variant="determinate" value={props.hardSkillsScore * 100} />
        </>}
    </>;
};

export default SimilaritiesBreakdown;
